module.exports = __webpack_public_path__ + "img/setld_logo_v1.2.653801a4.png";